import { render, staticRenderFns } from "./EditForumGroup.vue?vue&type=template&id=26afa234&scoped=true&"
import script from "./EditForumGroup.vue?vue&type=script&lang=js&"
export * from "./EditForumGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditForumGroup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditForumGroup.vue?vue&type=style&index=1&id=26afa234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afa234",
  null
  
)

export default component.exports